// Copies the chart rows and colours the clicked bar's key red on every row with
// the clicked switch; null when no row has that switch (leave the chart alone).
export const highlightClickedBar = (rows, clickedRow, id) => {
  if (!rows.some((row) => row.switch === clickedRow.switch)) {
    return null;
  }

  return rows.map((row) =>
    row.switch === clickedRow.switch
      ? { ...row, [`${id}Color`]: 'red' }
      : { ...row },
  );
};
